var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"legal-notes"}},[_c('router-link',{attrs:{"to":{ name: 'legal-notes' }}},[_vm._v("Impressum")]),_vm._v(" | "),_c('router-link',{attrs:{"to":{ name: 'privacy-policy' }}},[_vm._v(" Datenschutzerklärung ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }